import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaAward, FaLaptopCode, FaShieldAlt, FaUserShield, FaExchangeAlt, FaQrcode, FaSyncAlt, FaBolt } from 'react-icons/fa';

const MemberBenefits = () => {
    const { t } = useTranslation();

    const benefits = [
        {
            icon: <FaAward />,
            textKey: 'memberBenefits.audit',
        },
        {
            icon: <FaLaptopCode />,
            textKey: 'memberBenefits.cbs',
        },
        {
            icon: <FaShieldAlt />,
            textKey: 'memberBenefits.secureLoan',
        },
        {
            icon: <FaUserShield />,
            textKey: 'memberBenefits.insurance',
        },
        {
            icon: <FaExchangeAlt />,
            textKey: 'memberBenefits.neftRtgs',
        },
        {
            icon: <FaQrcode />,
            textKey: 'memberBenefits.qrCode',
        },
        {
            icon: <FaSyncAlt />,
            textKey: 'memberBenefits.nach',
        },
        {
            icon: <FaBolt />,
            textKey: 'memberBenefits.electricity',
        }
    ];

    return (
        <section className="py-20 bg-gray-50 relative overflow-hidden text-center">

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-16 max-w-3xl mx-auto">
                    <span className="text-secondary font-bold tracking-widest uppercase text-xs mb-3 block">{t('memberBenefits.badge')}</span>
                    <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6 font-display">
                        {t('memberBenefits.title')}
                    </h2>
                    <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
                    <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto">
                        {t('memberBenefits.subtitle')}
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {benefits.map((benefit, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-lg p-6 shadow-sm border border-gray-200 hover:border-primary/50 hover:shadow-lg transition-all duration-300 group flex flex-col items-center h-full"
                        >
                            <div
                                className="w-16 h-16 mb-6 rounded-full flex items-center justify-center text-3xl text-primary bg-primary/5 group-hover:bg-primary group-hover:text-white transition-all duration-300 transform group-hover:-translate-y-1"
                            >
                                {benefit.icon}
                            </div>
                            <p className="text-gray-800 font-semibold text-base leading-relaxed flex-grow flex items-center justify-center">
                                {t(benefit.textKey)}
                            </p>
                        </div>
                    ))}
                </div>


            </div>
        </section>
    );
};

export default MemberBenefits;
